export enum JourneyStepsRoutes {
  NEXT_STEPS = '/next-steps',
  YOUR_DETAILS = '/your-details',
  FINANCE_INSURANCE = '/finance-insurance',
  FINANCE = '/finance',
  PAYMENT = '/payment',
  CONFIRMATION = '/confirmation',
  IDENTITY_VERIFICATION = '/identity-verification',
  DEALER = '/dealer',
  EXTRAS = '/extras',
}
